const MS_IN_DAY = 1000 * 60 * 60 * 24;

/**
 * Returns difference between two dates in days
 *
 * @type {(date1: Date, date2: Date, toInt?: (x: number) => number)}
 */
export const diffDays = (date1, date2, toInt = Math.ceil) => {
	const diffTime = date2 - date1;
	return toInt(diffTime / MS_IN_DAY);
};
